<template>
    <div class="layerPointRelais" v-if="carrier && carrier.isRelay">
        <h2>Sélectionnez votre point relais</h2>

        <div v-show="!isLoadingColissimo">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="colissimoZipcode">Code postal</label>
                    <input v-model="colissimoZipcode" type="text" id="colissimoZipcode" name="colissimo[zipcode]" class="form-control" :class="'' === colissimoZipcode ? 'is-invalid' : ''"/>
                    <div v-if="'' === colissimoZipcode" class="invalid-feedback"><span class="error">Merci de renseigner le code postal.</span></div>
                </div>
                <div class="form-group col-md-6">
                    <label for="colissimoCity">Ville</label>

                    <div class="input-group">
                        <input v-model="colissimoCity" type="text" id="colissimoCity" name="colissimo[city]" class="form-control" :class="'' === colissimoCity ? 'is-invalid' : ''"/>
                        <div class="input-group-append">
                            <button @click="submitRelay" type="button" class="btn btn-primary">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div v-if="'' === colissimoCity" class="invalid-feedback"><span class="error">Merci de renseigner la ville.</span></div>
                    </div>

                </div>
            </div>

            <ponroy-google-map v-if="null !== colissimoPoints"
                               name="zone"
                               :lat="parseFloat(colissimoPoints[0].coordGeolocalisationLatitude)"
                               :lng="parseFloat(colissimoPoints[0].coordGeolocalisationLongitude)"
                               :markers="colissimoPoints"
                               :selectedMarker="colissimoPoint"
            >
            </ponroy-google-map>

            <ponroy-order-input-colissimo v-if="null !== colissimoPoints"
                                          :colissimoPoints="colissimoPoints"
                                          :selected="colissimoPoint">
            </ponroy-order-input-colissimo>
        </div>
        <div class="loader" v-show="isLoadingColissimo">
            <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
    </div>
</template>

<script>

    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderColissimo = {
        name: 'ponroy-order-colissimo',
        store,
        props: {
        },
        data() {
          return {
              colissimoCity: null,
              colissimoZipcode: null,
          }
        },
        computed: {
            ...mapGetters('order', ['shippingAddress', 'carrier', 'colissimoPoints', 'colissimoPoint', 'isLoadingColissimo']),
        },
        methods: {
            ...mapActions('order', [
                'getColissimoPoints',
            ]),
            submitRelay() {
                if (this.colissimoZipcode && this.colissimoCity) {
                    this.getColissimoPoints({'zipcode' : this.colissimoZipcode, 'city' : this.colissimoCity});
                }
            },
        },
        watch: {
            carrier(value) {
                if (this.shippingAddress && null !== value && true === value.isRelay) {
                    this.colissimoZipcode = this.shippingAddress.zipcode;
                    this.colissimoCity = this.shippingAddress.city;
                    this.getColissimoPoints({'zipcode' : this.colissimoZipcode, 'city' : this.colissimoCity});
                }
            }
        },
    };

    export default OrderColissimo;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderColissimo.vue